import type { PortalApplication } from '../model/portalModels';

export type ApplicationRuntimeState = 'ready' | 'maintenance' | 'system-error';

export function resolveApplicationRuntimeState(status: string): ApplicationRuntimeState {
  if (status === 'ENABLED') return 'ready';
  if (status === 'MAINTENANCE') return 'maintenance';
  return 'system-error';
}

export function findRoutedApplication(
  applications: PortalApplication[],
  pathname: string,
): PortalApplication | undefined {
  return applications.find(application =>
    isApplicationPathname(application, pathname));
}

export function isApplicationPathname(
  application: PortalApplication,
  pathname: string | undefined,
): pathname is string {
  if (!pathname) return false;
  return pathname === application.entry.basePath
    || pathname.startsWith(`${application.entry.basePath}/`);
}

export type ApplicationSwitchPathname = Readonly<{
  pathname: string;
  restored: boolean;
}>;

export function resolveApplicationSwitchPathname(
  application: PortalApplication,
  rememberedPathname?: string,
): ApplicationSwitchPathname {
  if (isApplicationPathname(application, rememberedPathname)) {
    return { pathname: rememberedPathname, restored: true };
  }
  return {
    pathname: `${application.entry.basePath}${application.entry.defaultRoute}`,
    restored: false,
  };
}

export function findFirstEnabledApplication(
  applications: PortalApplication[],
): PortalApplication | undefined {
  return applications.find(application => application.status === 'ENABLED');
}

export function resolveCurrentApplication(
  applications: PortalApplication[],
  pathname: string,
  selectedApplicationCode?: string,
): PortalApplication | undefined {
  return findRoutedApplication(applications, pathname)
    ?? applications.find(application => application.appCode === selectedApplicationCode)
    ?? findFirstEnabledApplication(applications);
}
